import { RemoteFileLoader } from '@services/RemoteFileLoader';

export class LoadOpenIdXHR {
    public static async load(): Promise<any> {
        if ((window as any).Amazon?.IDP?.nativeXhr && (window as any).Amazon?.IDP?.xhr) {
            return Promise.resolve({});
        }

        try {
            return await RemoteFileLoader.loadScriptOnce({
                url: '/sentryJS/openid.xhr.min.js',
                cache: true,
            });
        } catch (error) {
            console.warn('LoadOpenIdXHR: Failed to load SentryJS script. This is expected in local development.', error);
            return Promise.resolve({});
        }
    }
}
